import { FC } from 'react';
import { Page } from 'layouts/Page';
import { Prp } from 'components/Prp';

export const PrpPage: FC = () => {
	return (
		<Page title="PRP – EAS Control Center">
			<Prp />
		</Page>
	);
};
